export default "__VITE_ASSET__65b032ff__"